import { Inbox } from 'lucide-react'
import type { ReactNode } from 'react'

import { EmptyState } from '@/components/feedback/EmptyState'
import { messages } from '@/lib/messages'

interface EmptyProps {
  title?: string
  hint?: string
  action?: ReactNode
}

/** Veri yüzeylerinin dört zorunlu durumundan biri (AGENTS.md §10). */
export function Empty({
  title = messages.states.emptyTitle,
  hint = messages.states.emptyHint,
  action,
}: EmptyProps) {
  return (
    <EmptyState
      title={title}
      description={hint}
      action={action}
      icon={<Inbox className="size-6" strokeWidth={1.5} />}
    />
  )
}
